'use client';

import { createContext, useContext } from 'react';
import { UserAnalyticsContextValue, DEFAULT_USER_ANALYTICS } from './types';

// Non-empty default so consumers rendered outside the provider read zeroes
// instead of crashing.
const defaultContextValue: UserAnalyticsContextValue = {
  data: DEFAULT_USER_ANALYTICS,
  isPreExistingUser: false,
  firstSeen: '',
  totalVisits: 0,
  getSectionVisits: () => 0,
  getSubsectionVisits: () => 0,
  ringVisits: 0,
  ringBuyVisits: 0,
  homeVisits: 0,
  homeBuyVisits: 0,
};

export const UserAnalyticsContext =
  createContext<UserAnalyticsContextValue>(defaultContextValue);

export const useUserAnalyticsContext = (): UserAnalyticsContextValue =>
  useContext(UserAnalyticsContext);
